import { FunctionComponent, useState } from 'react';
import { FieldErrorsImpl, UseFormRegister, UseFormWatch } from 'react-hook-form';
import { CardInfoFields } from './CardFormTypes';
import ApplyTheme from '../ApplyTheme';
import ValidationError from '../ValidationError';
import IconForCardNumber from '../CardIcons';

interface CardFormSingleLineProps {
  styleOverrides: {},
  formRef: React.RefObject<HTMLFormElement>,
  register: UseFormRegister<CardInfoFields>,
  errors: Partial<FieldErrorsImpl<{
    number: string;
    month: string;
    year: string;
    verification: string;
  }>>,
  watch: UseFormWatch<{
    number: string;
    month: string;
    year: string;
    verification: string;
  }>
}

export const CardFormSingleLine: FunctionComponent<CardFormSingleLineProps> = (props) => {
  const {
    styleOverrides,
    formRef,
    register,
    errors,
    watch
  } = props;
  const [inputFocus, setInputFocus] = useState<boolean>(false);

  function getFormControlClassName() {
    const hasError = Object.keys(errors).length;
    const formControlClass = 'form-control-single-line';
    const validityClass = hasError ? 'error' : '';
    return [formControlClass, validityClass].join(' ');
  };

  return (
    <>
      <ApplyTheme styleOverrides={styleOverrides} />
      <form ref={formRef}>
        <div className='form-control-single-line-wrapper'>
          <div className={getFormControlClassName()}>
            <div className="form-control-single-line--number">
              <IconForCardNumber number={watch('number')} inputFocus={inputFocus}>
                <input
                  {...register('number')}
                  type="tel"
                  placeholder="Card Number"
                  maxLength={16}
                  autoComplete='cc-number'
                  autoCorrect='off'
                  className={'form-control-single-line-input number-input-single'}
                  onFocus={() => setInputFocus(true)}
                  onBlur={() => setInputFocus(false)}
                />
              </IconForCardNumber>
            </div>
            <div className="form-control-single-line--month">
              <input
                {...register('month')}
                type="tel"
                placeholder="MM"
                maxLength={2}
                autoComplete='cc-exp-month'
                autoCorrect='off'
                className={'form-control-single-line-input'}
                aria-labelledby="expiration"
                aria-required
              />
            </div>
            <div>/</div>
            <div className="form-control-single-line--year">
              <input
                {...register('year')}
                type="tel"
                placeholder="YY"
                maxLength={2}
                autoComplete='cc-exp-year'
                autoCorrect='off'
                className={'form-control-single-line-input'}
                aria-labelledby="expiration"
                aria-required
              />
            </div>
            <div className="form-control-single-line--cvv">
              <input
                {...register('verification')}
                type="tel"
                placeholder="CVV"
                maxLength={4}
                autoComplete='cc-csc'
                autoCorrect='off'
                className={'form-control-single-line-input'}
                aria-labelledby="cvv"
                aria-required
              />
            </div>
          </div>
          <div>
            <ValidationError message={errors.number?.message} />
            <ValidationError message={errors.month?.message} />
            <ValidationError message={errors.year?.message} />
            <ValidationError message={errors.verification?.message} />
          </div>
        </div>
      </form>
    </>
  );
};
